var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 49,
    viewBox: "0 0 79 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.75 22.625L26.375 11.375M26.375 11.375H54.5M26.375 11.375L33.875 37.625L54.5 11.375M26.375 11.375L22.625 2M54.5 11.375L58.25 22.625M54.5 11.375L52.625 7.625L63.875 5.75V11.375M28.25 33.875C28.25 41.1237 22.3738 47 15.125 47C7.87625 47 2 41.1237 2 33.875C2 26.6263 7.87625 20.75 15.125 20.75C22.3738 20.75 28.25 26.6263 28.25 33.875Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.873 47C71.1218 47 76.998 41.1237 76.998 33.875C76.998 26.6263 71.1218 20.75 63.873 20.75C56.6243 20.75 50.748 26.6263 50.748 33.875C50.748 41.1237 56.6243 47 63.873 47Z",
    stroke: "#C18344",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.752 2H30.127",
    stroke: "#C18344",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRent);
export default __webpack_public_path__ + "static/media/rent.e1f6a61287449bf0fce34b97b5e228b2.svg";
export { ForwardRef as ReactComponent };